export default __webpack_public_path__ + "9c8a3641c39419c82621a5fc0a3cb908.png";